import { render } from "./LoaderIcon.vue?vue&type=template&id=e642b4c4"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/LoaderIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e642b4c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e642b4c4', __exports__)) {
    api.reload('e642b4c4', __exports__)
  }
  
  module.hot.accept("./LoaderIcon.vue?vue&type=template&id=e642b4c4", () => {
    api.rerender('e642b4c4', render)
  })

}


export default __exports__